<div class="hs-impressum px-3 pb-2 pt-1">
  <div>
    <span class="text-secondary">Powered by</span>
    <div class="hs-logo">
      <a href="https://ng.hslayers.org/" target="_blank">
        <img [src]="logoPath" alt="HSLayers-NG"
          [hidden]="logoDisabled">
      </a>
    </div>
    <span class="text-secondary">version <a href="https://github.com/hslayers/hslayers-ng/releases/tag/{{version}}"
      target="_blank">{{version}}</a></span>
  </div>
</div>
